export const MapProps = <T extends any = any>(block: any): T => {
  if (block == null || !block.fields) return {} as T;
  const {
    // name,
    // resoId,
    // disclaimer,
    title,
    cta,
    downloadLink,
    header,
    header2,
    img,
    img2,
    media,
    placeholderMedia,
    publicationLogo,
    videoUpload,
    posterImage,
    people,
    contentCard,
    flexCollarSlides,
    testimonials,
    jobListings,
    author,
    richText,
    images,
    propertyImages,
    tabs,
    valuePropCardContent,
    valuePropCardContentAlt,
    select,
    heading,
    subHeading,
    contact1Image,
    contact2Image,
  } = block.fields;
  let BlockMap = {
    // key: block.sys.id,
    id: block.sys.id,
    contentTypeId: block.sys.contentType.sys.id,
    // ----- CUSTOM UNIQUE PROPS BELOW -----
    // IMPORTANT NOTE: only add props that are not equal to itself
    cta: cta?.map((obj) => {
      const { url, text } = obj.fields;
      return {
        url: url,
        text: text,
      };
    }),
    downloadLink: downloadLink?.map((obj) => {
      const { url } = obj.fields;
      return {
        url: url,
      };
    }),
    header: header || title,
    header2: header2 || title,
    img: img?.fields?.file?.url,
    img2: img2?.fields?.file?.url,
    media: {
      url: media?.fields?.file?.url,
      fileName: media?.fields?.file?.fileName,
    },
    placeholderMedia: {
      url: placeholderMedia?.fields?.file?.url,
      fileName: placeholderMedia?.fields?.file?.fileName,
    },
    publicationLogo: publicationLogo?.fields?.file?.url,
    alt_text: img?.fields?.description,
    videoUpload: videoUpload?.fields?.file?.url,
    posterImage: posterImage?.fields?.file?.url,
    author: author,
    contentCard: contentCard?.map((obj) => {
      const { fields } = obj;
      const img = fields?.img?.fields?.file?.url;
      const title = fields?.title;
      const description = fields?.description;
      return {
        img,
        title,
        description,
      };
    }),
    testimonials: testimonials?.map((obj) => {
      const { fields } = obj;
      const title = fields?.title;
      const text = fields?.text;
      const author = fields?.author;
      return {
        title,
        text,
        author,
      };
    }),
    jobListings: jobListings?.map((obj) => {
      const { fields } = obj;
      const title = fields?.title;
      const type = fields?.type;
      const level = fields?.level;
      const location = fields?.location;
      const timeListed = fields?.timeListed;
      const url = fields?.url;
      return {
        title,
        type,
        level,
        location,
        timeListed,
        url,
      };
    }),
    people: people?.map((obj) => {
      const { fields } = obj;
      const img = fields?.img?.fields?.file?.url;
      const name = fields?.name;
      const description = fields?.description;
      const ctaUrl = fields?.ctaUrl;
      const ctaText = fields?.ctaText;
      return {
        img,
        name,
        description,
        ctaUrl,
        ctaText,
      };
    }),
    flexCollarSlides: flexCollarSlides?.map((s) => {
      const { fields } = s;
      const header = fields?.header;
      const img = fields?.img?.fields?.file?.url;
      const url = fields?.url;
      return {
        header,
        img,
        url,
      };
    }),
    richText,
    imgs: images?.map((i) => i?.fields?.file?.url),
    propertyImages: propertyImages?.map((p) => {
      const { fields } = p;
      const key = fields?.key;
      const header = fields?.header;
      const subHeader = fields?.subhead;
      const ctaUrl = fields?.ctaUrl;
      const image = fields?.image?.fields?.file?.url;
      const source = fields?.source;
      const videoSrc = fields?.videoSrc;
      const videoUpload = fields?.videoUpload?.fields?.file?.url;

      return {
        key,
        header,
        subHeader,
        ctaUrl,
        image,
        source,
        videoSrc,
        videoUpload,
      };
    }),
    tabs: tabs?.map((t) => ({
      type: t?.fields?.type,
      header: t?.fields?.header,
      tabListings: t?.fields?.items.map((i) => ({
        header: i?.fields?.header,
        bodyText: i?.fields?.bodyText,
        img: `https:${i?.fields?.img?.fields?.file?.url}`,
        rating: i?.fields?.rating,
        students: i?.fields?.students,
        distance: i?.fields?.distance,
        reviewAvg: i?.fields?.reviewAvg,
        reviewNum: i?.fields?.reviewNum,
      })),
    })),
    valuePropCardContent: valuePropCardContent?.map((obj) => {
      return {
        cardImage: obj.fields?.cardImage?.fields?.file?.url
          ? `https:${obj.fields?.cardImage.fields.file.url}`
          : '',
        cardHeadline: obj.fields?.cardHeadline,
        cardSubHeadline: obj.fields?.cardSubHeadline,
        cardDescription: obj.fields?.cardDescription,
      };
    }),
    valuePropCardContentAlt: valuePropCardContentAlt?.map((obj) => {
      return {
        cardImage: obj.fields?.cardImage?.fields?.file?.url
          ? `https:${obj.fields?.cardImage.fields.file.url}`
          : '',
        cardHeadline: obj.fields?.cardHeadline,
        cardSubHeadline: obj.fields?.cardSubHeadline,
        cardDescription: obj.fields?.cardDescription,
        links: obj.fields?.links,
      };
    }),
    statBlockProps: select ? select : [],
    heading: heading,
    subHeading: subHeading,
    contact1Image: `https:${contact1Image?.fields?.file?.url}`,
    contact2Image: `https:${contact2Image?.fields?.file?.url}`,
    className: block?.className || null,
  };

  // Search Hero

  // adds props that do not exist in BlockMap that are equal to itself
  for (const prop in block.fields) {
    if (!BlockMap[prop]) {
      BlockMap[prop] = block.fields[prop];
    }
  }
  return BlockMap as T;
};
